import { timezones } from './timeZones.json';

export const response = timezones;
